import { TFunction } from 'i18next';

export interface MessageFilterCategoryOption {
  value: string;
  label: string;
}

// Updated filter categories - Jan 2026
export const getMessageOutboxCategories = (t: TFunction): MessageFilterCategoryOption[] => [
  { value: 'not deleted', label: t('Show All Active') },
  { value: 'all', label: t('Show All') },
  { value: 'deleted', label: t('Show Only Deleted') },
];

export default getMessageOutboxCategories;
